import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { RootState } from "../../store/store";
import { AuthService } from "../../authentification/service";
import { handleError } from "../functions/handleError";
import {
  applyImpersonationToken,
  getImpersonator,
} from "../functions/impersonation";

const ImpersonationBanner = () => {
  const { t } = useTranslation();
  const { token, userData } = useSelector((state: RootState) => state.auth);
  const [isExiting, setIsExiting] = useState(false);

  const impersonator = getImpersonator(token || null);

  if (!impersonator) return null;

  const impersonatedName =
    [userData?.firstName, userData?.lastName].filter(Boolean).join(" ") ||
    userData?.email ||
    "";

  const handleExit = () => {
    setIsExiting(true);
    AuthService.exitImpersonation()
      .then((response) => {
        if (response?.token) {
          applyImpersonationToken(response.token, "/users");
        } else {
          setIsExiting(false);
        }
      })
      .catch((error) => {
        setIsExiting(false);
        handleError(error);
      });
  };

  return (
    <div className="header-element ms-2">
      <div className="d-flex align-items-center gap-2 px-2 py-1 rounded bg-danger-transparent border border-danger border-opacity-25">
        <i className="ri-spy-line text-danger fs-16 lh-1" />
        <div className="lh-1 d-none d-md-block">
          <span className="fw-semibold text-danger d-block fs-12">
            {t("auth.impersonating", { name: impersonatedName })}
          </span>
          {!!impersonator.email && (
            <small className="text-muted fs-11">
              {t("auth.impersonatedBy", { email: impersonator.email })}
            </small>
          )}
        </div>
        <button
          className="btn btn-sm btn-danger"
          onClick={handleExit}
          disabled={isExiting}
        >
          {t("button.exitImpersonation")}
        </button>
      </div>
    </div>
  );
};

export default ImpersonationBanner;
